import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl } from "../utils/helper";

const CardNews = ({ data, ...props }) => {
  const imageURL =
    data.image || _getBaseUrl("src/assets/dummy/placeholder.jpg", true);

  return (
    <div className="h-full block flex flex-col justify-between rounded-sm sm:rounded-md content-card--link">
      <a
        href={data.permalink}
        className="flex gap-x-4 sm:gap-x-0 sm:block group"
      >
        <div className="w-1/3 sm:w-full">
          <img
            src={imageURL}
            alt={data.imageAlt}
            className="aspect-[100/64] sm:aspect-[29/16] object-center object-cover w-full rounded-sm sm:rounded-md sm:mb-4"
          />
        </div>
        <div className="w-2/3 sm:w-full">
          <div className="content-card--date transition-all duration-200 group-hover:text-ideaBlue100">
            {data.publishedDate}
          </div>
          <h3 className="content-card--heading transition-all duration-200 group-hover:text-ideaBlue100">
            {data.title}
          </h3>
        </div>
      </a>
      {isArray(data.tags) && data.tags.length > 0 && (
        <div className="content-tags-wrapper hidden sm:flex flex-wrap justify-start">
          {data.tags.map((tag, i) => (
            <a className="content-tag" href={tag.permalink}>
              {tag.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardNews;
